import RevendedoresView from './RevendedoresView.vue'
import CreacionRevendedoresView from './CreacionRevendedoresView.vue'
import EdicionRevendedoresView from './EdicionRevendedoresView.vue'
import RegistroRevendedorView from './RegistroRevendedorView.vue'

export default [
  {
    path: '',
    meta: { requiresAuth: true },
    component: RevendedoresView
  },
  {
    path: 'nuevo',
    meta: { requiresAuth: true },
    component: CreacionRevendedoresView
  },
  {
    path: 'edicion/:id',
    meta: { requiresAuth: true },
    component: EdicionRevendedoresView
  },
  {
    path: 'registra-revendedor',
    component: RegistroRevendedorView
  }
  
];